import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadRuntimeConfig } from './config/runtime';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

loadRuntimeConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
